import React, { Fragment } from 'react';

interface MultilineTextProps {
  text: string | null | undefined;
}

/**
 * 改行を含む文字列を&lt;br/&gt;で区切って表示する。
 * dangerouslySetInnerHTMLによるHTML注入を避けるため、実際のReact要素として描画する。
 */
export const MultilineText: React.FC<MultilineTextProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  const lines = text.split(/\r\n|\r|\n/);

  return (
    <>
      {lines.map((line, index) => (
        <Fragment key={`${index}-${line}`}>
          {index > 0 && <br />}
          {line}
        </Fragment>
      ))}
    </>
  );
};
